export const PHONE = "1154594235";
export const EMAIL = "contacto@perfumeriamundial.ar";
export const WHATSAPP_LINK = `https://api.whatsapp.com/send/?phone=54${PHONE}&text&type=phone_number&app_absent=0`;
export const FB_LINK = "https://www.facebook.com/PerfumeriaMundialOficial";
export const CLIENTS_COMMERCIAL_NAME = "Perfumería Mundial";
